import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Timeline from 'components/Timeline'
import RealizationTimelineOverlapping from 'workspace/RealizationTimelineOverlapping'
import RealizationTimelineBlock from 'workspace/RealizationTimelineBlock'
import { selectNavigationRange } from 'containers/Navigation/selectors'

const RealizationTimeline = ({
  id,
  date,
  scope,
  symbol,
  realizationIds,
  overlappingIds,
  isLoading,
  lunchBreaks,
  start,
  finish
}) => (
  <Timeline
    scope={scope}
    date={date}
    header={symbol}
    isLoading={isLoading}
    size={2}
    lunchBreaks={lunchBreaks}
    overlappingIds={overlappingIds}
    Overlap={RealizationTimelineOverlapping}
    start={start}
    finish={finish}
  >
    {realizationIds.map(sid => (
      <RealizationTimelineBlock key={sid} id={sid} />
    ))}
  </Timeline>
)

RealizationTimeline.propTypes = {
  id: PropTypes.number.isRequired,
  symbol: PropTypes.string.isRequired,
  date: PropTypes.object.isRequired,
  scope: PropTypes.oneOf(['day', 'week', 'range']).isRequired,
  realizationIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  overlappingIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  lunchBreaks: PropTypes.arrayOf(
    PropTypes.shape({
      startsAfterMidnight: PropTypes.number.isRequired,
      duration: PropTypes.number.isRequired
    })
  ),
  isLoading: PropTypes.bool,
  start: PropTypes.object,
  finish: PropTypes.object
}

const mapStateToProps = (state, { id }) => ({
  date: selectNavigationRange(state).from,
  scope: state.navigation.shift ? 'range' : state.navigation.scope,
  start: state.navigation.shift ? selectNavigationRange(state).from : undefined,
  finish: state.navigation.shift ? selectNavigationRange(state).to : undefined,
  ...state.locations.allById[id],
  realizationIds: state.realizations.idsByLocation[id],
  overlappingIds: state.overlappings.idsByLocation[id],
  isLoading: state.locations.isLoadingRealizationsById[id]
})

export default connect(mapStateToProps)(RealizationTimeline)
